import { Component, Ref, Prop } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

import './PopUp.scss';

@Component
export class PopUp extends ThemeComponent {
    @Ref() buttonClose!: HTMLButtonElement;
    @Ref() popUpInner!: HTMLElement;
    @Ref() popUpOverlay!: HTMLElement;

    init() {
        this.handlePopUpDisplay();

        const closeTriggers = [this.buttonClose, this.popUpOverlay];
        for(const trigger of closeTriggers) {
            this.$listen(trigger, 'click', () => {
                this.handlePopupClose();
            });
        }
    }

    handlePopUpDisplay() {
        const sectionId = this.popUpInner?.getAttribute('data-section-id');
        const sectionTimer = Number(this.popUpInner?.getAttribute('data-timer'));

        if (!sectionId || isNaN(sectionTimer)) {return;}

        if (sessionStorage.getItem(`popupClosed-${sectionId}`) != 'true') {
            const parentSection = document.getElementById(sectionId || "");

            if(parentSection) {
                setTimeout(() => parentSection.classList.remove('hide'), sectionTimer * 1000);
            }
        }
    }

    handlePopupClose() {
        const sectionId = this.popUpInner?.getAttribute('data-section-id');
        if (!sectionId) {return;}

        document.getElementById(sectionId)?.classList.add('hide');
        sessionStorage.setItem(`popupClosed-${sectionId}`, 'true');
    }
}
